/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/


import { Typography, TypographyProps } from "@mui/material";

type SchrittTextProps = Pick<TypographyProps, "children">

export default function SchrittText(props: SchrittTextProps) {
    return (
        <Typography
            color="textSecondary"
            variant="subtitle1"
            paragraph
        >
            {typeof props.children === "string" ? (
                <span dangerouslySetInnerHTML={{ __html: props.children }} />
            ) : (
                props.children
            )}
        </Typography>
    );
}